import React, { useMemo } from 'react';
import { Spacer, Box, DarkMode } from '@chakra-ui/react';
import { Layout } from '../Layout/component.js';
var Navbar = function Navbar(_ref) {
  var _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'relative' : _ref$position,
    _ref$topOffset = _ref.topOffset,
    topOffset = _ref$topOffset === void 0 ? '0px' : _ref$topOffset,
    leftMenuItems = _ref.leftMenuItems,
    rightMenuItems = _ref.rightMenuItems,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'light' : _ref$variant,
    _ref$bg = _ref.bg,
    bg = _ref$bg === void 0 ? 'surface-primary' : _ref$bg;
  var sx = useMemo(function () {
    if (!position || position !== 'sticky') {
      return undefined;
    }
    return {
      position: 'sticky',
      zIndex: 'sticky',
      top: topOffset,
      bg: bg
    };
  }, [position]);
  var innerFlex = /*#__PURE__*/React.createElement(Layout, {
    gap: 2,
    variant: 'flex'
  }, leftMenuItems, !!rightMenuItems && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, null), rightMenuItems));
  if (variant === 'dark') {
    return /*#__PURE__*/React.createElement(Box, {
      as: "nav",
      sx: sx
    }, /*#__PURE__*/React.createElement(DarkMode, null, innerFlex));
  }
  return /*#__PURE__*/React.createElement(Box, {
    as: "nav",
    sx: sx
  }, innerFlex);
};
Navbar.displayName = "Navbar";
export { Navbar };